<template>
  <div class="content" v-if="!uploaded">
    <div class="condition-box condition-video-box" style="margin-bottom: 20px;">
      <p>
        温馨提示： 请于2024.5.19上午10:00 前上传视频；
      </p>
    </div>
    <div class="condition-box condition-video-box">
      <h2 class="title">视频赛要求</h2>
      <p>
        1.入围中国大陆半决赛队伍需参加视频赛，内容需要体现团队各成员画面及GBC,  AICPA & CIMA或CGMA相关元素，每支队伍仅限上传一个视频<br />
        2.团队视频时长要求2分钟内，小于2GB， MP4格式, 横向拍摄<br />
        3.队长将视频上传至GBC官方报名平台，由公会于官方平台发起投票
      </p>
    </div>
    <div class="info-box">
      <el-form>
        <!-- <el-form-item label="团队名称" style="width: 280px">
          <el-input v-model="newProcess.entries_name" placeholder="请输入团队名称"></el-input>
        </el-form-item>
        <el-form-item label="团队口号">
          <el-input type="textarea" rows="2" v-model="newProcess.introduce" placeholder="请输入团队口号"></el-input>
        </el-form-item> -->
        <el-form-item class="upform" label="团队照片" required >
          <span
            >（必填，要求：图片命名学校名称+队伍名称；格式jpg、png；大小≤2MB）</span
          >
          <el-upload
            class="avatar-uploader"
            :headers="uploadHeader"
            :action="imageUrl + '/user/upload'"
            :data="uploadData"
            :show-file-list="false"
            :on-success="handleAvatarSuccess2"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
          >
            <img v-if="newProcess.photo" :src="imageUrl + newProcess.photo" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item class="upform" label="封面设置">
          <span
            >（要求：图片命名学校名称+队伍名称;格式jpg、png;大小≤2MB）</span
          >
          <el-upload
            class="avatar-uploader"
            :headers="uploadHeader"
            :action="imageUrl + '/user/upload'"
            :data="uploadData"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            accept=".jpg,.png,.jpeg"
          >
            <img v-if="newProcess.entries_thumb" :src="imageUrl + newProcess.entries_thumb" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item class="upform"  label="上传视频">
          <span>（文件大小2GB以内的视频(横向拍摄)，推荐MP4格式）</span>
          <div class="video_box">
            <el-upload
            class="avatar-uploader avatar-uploader-video"
            :show-file-list="false"
            accept=".wmv, .asf, .asx, .rm, .rmvb, .mp4, .3gp, .mov, .m4v, .avi, .dat, .mkv, .flv, .vob"
            :action="'#'"
            :before-upload="(file)=>{beforeUpload(file)}"
            :http-request="(file)=>{uploadBefore(file)}"
            multiple
          >
            <div v-if="!fileInfo.url">
              <img src="../../assets/images/team/upload.png" alt="" />
              <p>点击上传</p>
              <el-progress :percentage="parseInt(jindu*100)" v-show="uploadVideoProgressShow" :color="customColor"></el-progress>
            </div>
            <div v-else style="height:100%">
              
              <video style="height:100%" autoplay controls :src="fileInfo.url"></video>
            </div>
            </el-upload>
            <div v-show="fileInfo.url" class="btn_del" @click="toDel">
                <i class="el-icon-close"></i>
              </div>
          </div>
          
        </el-form-item>
      </el-form>
      <div class="team-button-box">
        <el-button class="pre" size="small" type="primary" @click="next" v-loading="subLoading">提交</el-button>
      </div>
    </div>
  </div>
  <div class="status-box" v-else>
    <div class="img-box">
      <img src="../../assets/images/team/video_submit.png" alt="" />
      <p>作品已提交成功！</p>
      <!-- <el-button class="next">下一步</el-button> -->
    </div>
  </div>
</template>

<script>
import {
  apiGetOssConfig,
  apiUploadFileInfo,
  apiSetProcess,
  apiGetProcess,
apiGetReportTeamData
} from '../../plugins/apis'
import OSS from "ali-oss";

export default {  
  data() {
    return {
      uploaded:false,
      imageUrl: process.env.VUE_APP_API_URL,
      uploadHeader:{ Authorization: window.localStorage.app_token },
      newProcess:{},
      fileInfo:{
        url:''
      },
      team:null,
      uploadData:{file_source:1},
      jindu:0,
      size:'',
      uploadVideoProgressShow:false,
      customColor:'#733085',
      subLoading:false
    };
  }, 
  props:['round','label'],
  // 组件方法
  methods: {
    toDel(){
      this.fileInfo.url = ''
      this.uploadVideoProgressShow = false
    },
    async getView(){
      let res = await apiGetProcess(this.round.round_id,this.label)
      if(res.code === 200){
        this.uploaded = res.data ? true:false
      }
      await this.getTeam()
      
    },
    async getTeam() {
			let res = await apiGetReportTeamData(this.round.round_id)
			if (res.code === 200) {
				this.team = Array.isArray(res.data.teamData) ? {} : res.data.teamData
			}
		},
    async next(){
      this.subLoading = true
      let _data = this.fileInfo
      _data['file_source'] = 3;
      console.log('_data',_data,this.newProcess)
      if(this.newProcess.photo === undefined || this.newProcess.photo == '' || !this.newProcess.photo){
        this.$message.error('请上传团队照片')
        this.subLoading = false
        return
      }
      let res = await apiUploadFileInfo(_data)
      if(res.code !== 200 ){
        this.$message.error(res.message)
        this.subLoading = false
        return
      }
      this.newProcess.file_id = res.data.file_id

      if(this.newProcess.file_id === undefined || this.newProcess.file_id === '' || !this.newProcess.file_id){
        this.$message.error('请上传作品')
        this.subLoading = false
        return
      }
      await apiSetProcess(this.round.round_id,this.label,this.newProcess)
      await this.getView()
      this.$Bus.$emit('reload_NowProcess');
      this.subLoading = false
    },
    beforeUpload(file){
      if(this.uploadVideoProgressShow){
        this.$error('当前状态不可上传文件');
        return false;
      }
      
      
      let that = this
      this.jindu = '';
      this.size = '';
      this.fileInfo['name'] = file.name
      this.fileInfo['type'] = file.name.split('.').pop()//文件格式
      this.fileInfo['size'] = (file.size/1000000).toFixed(2)*1000
      this.fileInfo['file_source'] = 3
      this.fileInfo['status'] = 2
      
      var url = URL.createObjectURL(file);
      var audioElement = new Audio(url);
      var duration;
      audioElement.addEventListener("loadedmetadata", function () {
          duration = audioElement.duration; //时长为秒，小数，182.36
          that.fileInfo['length'] = parseInt(duration)
      });
      
      
    },
    uploadBefore(file){
      const isLt2G = file.file.size / 1024 /1024/1024 <= 2;
      const isMP4 = file.file.type === 'video/mp4';
      if (!isMP4) {
        this.$message.error("上传视频只能是MP4格式!");
        return false
      }
      if (!isLt2G) {
        this.$message.error("上传文件大小不能超过 2GB!");
        return false
      }
       
      this.fileInfo.url = ''
      this.jindu = 0
      this.uploadVideoProgressShow = true
      this.uploadMutil(file);
      
    },
    async uploadMutil(a) {
      let that = this
      let res = await apiGetOssConfig() 
      let config = {
          region: res.data.oss_region,
          //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
          accessKeyId: res.data.oss_key,
          accessKeySecret: res.data.oss_secret,
          bucket: res.data.oss_bucket,
      }
      let client = new OSS(config); 
      let maxSize = a.file.size/1000000;
      try {
          let uploadOptions = {
              parallel: 15,
              headers: { "x-oss-forbid-overwrite": true },
              progress: function(a) {
                  if(that.chooseCancel){
                      that.tipMsg("已取消上传","warning");
                      throw new Error("取消上传");
                  } 
                  that.jindu = a.toFixed(2);
                  that.size = (maxSize * that.jindu).toFixed(2);
              },
          };
          let file_name = new Date().valueOf() + a.file.name;
          client.multipartUpload(this.round.year+"/normal/" + this.team.name + '/' + file_name,a.file,uploadOptions)
              .then(() => { 
                that.$set(that.fileInfo,'url',"https://" +config.bucket +"." +config.region +".aliyuncs.com/" +this.round.year+"/normal/" + this.team.name + '/' + file_name)
              })
              .catch((e) => {
                  if (e.name === "FileAlreadyExistsError") {
                      this.$error("此文件名称已存在");
                  }
                  this.uploadVideoProgressShow = false
                  console.log(e)
              });
      } catch (e) {
          this.uploadVideoProgressShow = false
          // 捕获超时异常。
          if (e.code === "ConnectionTimeoutError") {
              this.$message.error("文件上传超时,请重试");
              console.log("TimeoutError");
              // do ConnectionTimeoutError operation
          }
          console.log("error", e);
      }
  },
    handleAvatarSuccess(res) {
      if(res.code === 200){
        this.$set(this.newProcess,'entries_thumb',res.data.file.path)
        this.$message.success('上传成功')
      }
    },
    handleAvatarSuccess2(res) {
      if(res.code === 200){
        this.$set(this.newProcess,'photo',res.data.file.path)
        this.$message.success('上传成功')
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';

      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG或者PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
  },
  async mounted() { 
    await this.getView()
  },
};
</script> 

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #733085;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: contain;
}
</style>
